<template>
    <div>
        <h3 class="py-3">Communication</h3>

        <div class="py-2">
            <span class="font-weight-600">Notify customers by email </span>
        </div>

        <div class="mt-2">
            <label>Notification Type</label>

            <div class="col-10 pl-0">
                <v-select 
                    :options="emailList" 
                    label="emailOption" 
                    placeholder="Select an option"
                    :append-to-body="true"
                    :value="emailSelection" 
                    @input="changeStatusSelected">
                </v-select>
            </div>

            <div class="mt-2">
                <span v-if="emailSelection.emailType === 'EventCancelRiskGroup' || emailSelection.emailType === 'EventWarningRiskGroup'" class="color-1 fs-small">
                    Emails will be sent to customers whose reservations are in <strong>booked</strong>, <strong>rebooked</strong>, or <strong>pending</strong> status.
                </span>

                <span v-if="emailSelection.emailType === 'EventPendingInformation'" class="color-1 fs-small">
                    Emails will be sent to customers whose reservations are in <strong>pending</strong> status.
                </span>
            </div>
        </div>
    </div>
</template>

<script>
	import extendedVSelect from '@/extends/vue-select'

    export default {
        data() {
            return {
                emailList: [
                    {emailOption: 'Cancellation of at-risk customers', emailType: 'EventCancelRiskGroup'}, 
                    {emailOption: 'Not recommending at-risk customers', emailType: 'EventWarningRiskGroup'}, 
                    {emailOption: 'Pending reservations due to min/max settings', emailType: 'EventPendingInformation'}
                ],
                emailSelection: []
            }
        },
        methods: {
            changeStatusSelected(e) {
                this.emailSelection = e;
                this.eventHub.$emit('email-selection', e.emailType);
            }
        },
        components: {
			vSelect: extendedVSelect,
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaCommunication.vue?4f6cde11